<template>
    <div id="e-content">
        <div class="f-content">
            <div class="large-empty bakim">
                <i class="fa fa-exclamation-triangle fa-3x"></i>
                <span>
                    Bir hata oluştu
                    <a href="https://pediatrim.net">pediatrim.net</a> adresine
                    girmeyi tekrar deneyin
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Error",
    created() {},
};
</script>

<style lang="scss">
</style>